import { combineReducers } from 'redux';

import { SAVE_ROUTER_PARAMS, NEED_REFRESH } from 'app/common/actions/settings/current';
import { SETTINGS_REQUEST, SETTINGS_SUCCESS, SETTINGS_FAILURE } from 'app/common/actions/settings/load';
import { STUDENTS_SUCCESS } from 'app/actions/students';
import { SCHOOLS_SUCCESS } from 'app/actions/schools';

import passages from './passages';
import events from './events';
import fav from './fav';
import identifiers from './identifiers';
import shop from './shop';


const defaultState = {
  // данные из params роутера для перехода между приложениями,
  // не содержащими эти значения в параметрах
  id: 0, // это id студента (имена совпадают с их аналогами в params)
  schoolId: 0, // id школы
  //
  // disconnected: false,
  needRefresh: false,
  loading: true, // процесс загрузки настроек
};


const current = (state = defaultState, action) => {
  // // коннект/дисконнект
  // if (state.disconnected && action.type === CONNECT) {
  //   return { ...state, ...{ disconnected: false } };
  // }
  // if (!state.disconnected && action.type === DISCONNECTED) {
  //   return { ...state, ...{ disconnected: true } };
  // }
  if (action.type === NEED_REFRESH) {
    return { ...state, needRefresh: action.payload };
  }
  // сохранение параметров роутера
  if (!state.id && action.type === STUDENTS_SUCCESS && action.payload.keys[0]) {
    return { ...state, ...{ id: action.payload.keys[0] } };
  }
  if (!state.schoolId && action.type === SCHOOLS_SUCCESS && action.payload.keys[0]) {
    return { ...state, ...{ schoolId: action.payload.keys[0] } };
  }
  if (action.type === SAVE_ROUTER_PARAMS) {
    return { ...state, ...{ ...action.payload } };
  }
  // процесс загрузки настроек
  if (action.type === SETTINGS_REQUEST) {
    return { ...state, loading: true };
  }
  if (action.type === SETTINGS_SUCCESS || action.type === SETTINGS_FAILURE) {
    return { ...state, loading: false };
  }
  return state;
};

export default combineReducers({
  current,
  passages,
  events,
  fav,
  identifiers,
  shop,
});
